(function($){
	const htmlHasClass = (_class) => { return $('html').hasClass(_class); };
	const siteName = 'thermos';
	const a = 'is-active';
	const v = 'is-visible';
	const slideSpeed = '300';

	THERMOS = {
		va: {
			pathname: location.pathname,
			isEnglish: /^\/english\//.test(location.pathname) ? true : false,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision() {
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					// 置換完了時にカスタムイベントを発火
					document.dispatchEvent(new Event('localincludeLoaded'));

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);

					document.dispatchEvent(new Event('localincludeLoaded'));
					_this.loadDelayScript();
				});
			} else {
				document.dispatchEvent(new Event('localincludeLoaded'));
				_this.loadDelayScript();
			}
		},
		getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for(var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle() {
			var $switch = $('.js-toggle');

			$switch.on('click', (e) => {
				$(e.currentTarget).toggleClass(a);
				$(e.currentTarget).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll() {
			$('a[rel="scroll"]').on('click', (event) => {
				var speed = 1200;
				if(/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed){
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (THERMOS.va.window.width < THERMOS.va.device.sp) {
						if (THERMOS.va.pathname === '/company/history/corporate_chronology.html') {
							pos -= 100;
						} else {
							pos -= 90;
						}
					} else {
						pos -= 106;
					}
				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		easeScrollHash() {
			const hash = location.hash;
			if(hash) {
				$(window).on('load', () => {
					$('html, body').css('display', 'none');

					setTimeout(() => {
						$('html, body').css('display', 'block');

						var _hash = '#' + hash.split('#')[1];
						var pos = $(_hash).offset().top;

						if(THERMOS.va.window.width < THERMOS.va.device.sp) {
							pos -= 90;
						} else {
							pos -= 106;
						}
						$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 100);
				});
			}
		},
		pageTop() {
			let $pagetop = document.querySelector('.footer-pagetop');
			if ($pagetop) {
				let optionsTop = {
					root: null,
					rootMargin: `100px 0px ${document.body.clientHeight}px 0px`,
					threshold: 1
				};

				const callbackTop = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							$pagetop.classList.remove('is-active');
						} else {
							$pagetop.classList.add('is-active');
						}
					});
				};
				let observerTop = new IntersectionObserver(callbackTop, optionsTop);
				observerTop.observe(document.body);

				const callbackBottom = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							$pagetop.classList.add('is-bottom');
						} else {
							$pagetop.classList.remove('is-bottom');
						}
					});
				};
				let observerBottom = new IntersectionObserver(callbackBottom, {});
				observerBottom.observe(document.querySelector('.footer-nav'));
			}
		},
		setModal() {
			const createModal = (_appendHTML) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
							}, 400);
						});
					});
				});
			};

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<span class="mod-modal-closeBtn"><i class="icon icon-close"></i></span>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML);
				});
			});
		},
		headerMenu() {
			const f = 'is-fixed';
			const o = 'is-open';
			let $header = document.querySelector('.header');
			let $headerNav = document.querySelector('.header-nav');
			let $headerMegaSwitch = document.querySelectorAll('.header-nav .js-megaMenuOpen');
			let $headerClose = document.querySelectorAll('.js-header-close');
			let $hamburger = document.querySelector('.header-hamburger');
			let $search = document.querySelector('.header-search');
			let $searchBtn = document.querySelectorAll('.js-header-search');
			let $overlay = document.querySelector('.header-overlay');
			let $container = document.querySelector('.container');

			const fixedOnContainer = () => {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.top = -1 * scrollTopNow;
				$container.style.left = 0;
				document.body.classList.add(f);
			};
			const fixedOffContainer = () => {
				$container.style.position = 'static';
				document.body.classList.remove(f);
				window.scrollTo({ top: scrollTopNow });
			};

			// メガメニュー開閉
			const megaMenu = () => {
				$headerMegaSwitch.forEach((ele) => {
					ele.addEventListener('click', () => {
						if (ele.classList.contains(a)) {
							// Close
							ele.classList.remove(a);

							if (THERMOS.va.window.width > THERMOS.va.device.desktop) {
								ele.nextElementSibling.classList.remove(v);
								setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
								$header.classList.remove(o);
								$overlay.classList.remove(v);
								setTimeout(() => { $overlay.classList.remove(a); }, 400);
							} else {
								ele.nextElementSibling.style.height = null;
							}
							// fixedOffContainer();
						} else {
							// Open
							if (THERMOS.va.window.width > THERMOS.va.device.desktop) {
								// 他のメニューを閉じる
								$headerMegaSwitch.forEach((ele2) => {
									if (ele2.nextElementSibling.classList.contains(a)) {
										ele2.classList.remove(a);
										ele2.nextElementSibling.classList.remove(v);
										setTimeout(() => { ele2.nextElementSibling.classList.remove(a); }, 400);
									}
								});
								// サイト内検索閉じる
								if ($search.classList.contains(a)) {
									$search.classList.remove(v);
									setTimeout(() => { $search.classList.remove(a); }, 400);
								}
								// オーバーレイが無ければ出す
								if (!$overlay.classList.contains(a)) {
									$overlay.classList.add(a);
									setTimeout(() => { $overlay.classList.add(v); }, 100);
									// fixedOnContainer();
								}
							}

							$header.classList.add(o);
							ele.classList.add(a);
							ele.nextElementSibling.classList.add(a);
							if (THERMOS.va.window.width > THERMOS.va.device.desktop) {
								setTimeout(() => { ele.nextElementSibling.classList.add(v); }, 100);
							} else {
								ele.nextElementSibling.style.height = ele.nextElementSibling.scrollHeight + 'px';
							}
						}
					});
				});
			};
			megaMenu();

			// サイト内検索開閉
			const setSiteSearch = () => {
				$searchBtn.forEach((ele) => {
					ele.addEventListener('click', () => {
						if ($search.classList.contains(a)) {
							// Close
							$search.classList.remove(v);
							setTimeout(() => { $search.classList.remove(a); }, 400);
							$header.classList.remove(o);
							$overlay.classList.remove(v);
							setTimeout(() => { $overlay.classList.remove(a); }, 400);
							// fixedOffContainer();
						} else {
							// Open
							if (THERMOS.va.window.width > THERMOS.va.device.desktop) {
								// [PC] 他のメニューを閉じる
								$headerMegaSwitch.forEach((ele) => {
									if (ele.nextElementSibling.classList.contains(a)) {
										ele.classList.remove(a);
										ele.nextElementSibling.classList.remove(v);
										setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
									}
								});
							} else {
								// [SP] ハンバーガーメニューを閉じる
								if ($hamburger.classList.contains(a)) {
									$headerNav.classList.remove(v);
									setTimeout(() => { $headerNav.classList.remove(a); }, 400);
									$hamburger.classList.remove(a);
								}
							}

							// オーバーレイが無ければ出す
							if (!$overlay.classList.contains(a)) {
								$overlay.classList.add(a);
								setTimeout(() => { $overlay.classList.add(v); }, 100);
								// fixedOnContainer();
							}

							$header.classList.add(o);
							$search.classList.add(a);
							setTimeout(() => { $search.classList.add(v); }, 100);
						}
					});
				});
			}
			setSiteSearch();

			// [PC] Closeボタンでメガメニュー・サイト内検索メニューを閉じる
			const closeBtn = () => {
				$headerClose.forEach((ele) => {
					ele.addEventListener('click', () => {
						ele.closest('div').classList.remove(v);
						setTimeout(() => { ele.closest('div').classList.remove(a); }, 400);
						if (ele.closest('div').previousElementSibling.classList.contains(a)) { ele.closest('div').previousElementSibling.classList.remove(a); }
						$header.classList.remove(o);
						$overlay.classList.remove(v);
						setTimeout(() => { $overlay.classList.remove(a); }, 400);
						// fixedOffContainer();
					});
				});
			};
			closeBtn();

			// [共通]オーバーレイエリア押下でメニューを閉じる
			const closeOverlay = () => {
				$overlay.addEventListener('click', () => {
					$headerMegaSwitch.forEach((ele) => {
						if (ele.nextElementSibling.classList.contains(a)) {
							ele.classList.remove(a);
							ele.nextElementSibling.classList.remove(v);
							setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
						}
					});
					if ($search.classList.contains(a)) {
						$search.classList.remove(v);
						setTimeout(() => { $search.classList.remove(a); }, 400);
					}
					$header.classList.remove(o);
					$overlay.classList.remove(v);
					setTimeout(() => { $overlay.classList.remove(a); }, 400);
					// fixedOffContainer();
				});
			};
			closeOverlay();

			// [SP] ハンバーガーメニュー
			const setHamburger = () => {
				$hamburger.addEventListener('click', (e) => {
					if ($hamburger.classList.contains(a)) {
						// Close
						$headerNav.classList.remove(v);
						$overlay.classList.remove(v);
						setTimeout(() => {
							$headerNav.classList.remove(a);
							$overlay.classList.remove(a);
						}, 400);
						$hamburger.classList.remove(a);
						$header.classList.remove(o);
						// fixedOffContainer();
					} else {
						// Open
						// サイト内検索閉じる
						if ($search.classList.contains(a)) {
							$search.classList.remove(v);
							setTimeout(() => { $search.classList.remove(a); }, 400);
						}

						$header.classList.add(o);
						$hamburger.classList.add(a);
						$headerNav.classList.add(a);
						setTimeout(() => { $headerNav.classList.add(v); }, 100);

						// オーバーレイが無ければ出す
						if (!$header.classList.contains(a)) {
							$overlay.classList.add(a);
							setTimeout(() => { $overlay.classList.add(v); }, 100);
							// fixedOnContainer();
						}
					}
				});
			};
			setHamburger();

			// [PC] ESCキー押下でメガメニューを閉じる
			const closeESCKey = () => {
				document.addEventListener('keydown', (e) => {
					if (e.key === 'Escape') {
						if ($overlay.classList.contains(a)) {
							$headerMegaSwitch.forEach((ele) => {
								if (ele.nextElementSibling.classList.contains(a)) {
									ele.classList.remove(o);
									ele.nextElementSibling.classList.remove(v);
									setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 400);
								}
							});
							$header.classList.remove(o);
							$overlay.classList.remove(v);
							setTimeout(() => { $overlay.classList.remove(a); }, 400);
							// fixedOffContainer();
						}
					}
				});
			};
			closeESCKey();

			// スクロール時小さくする
			const hiddenHeaderOnScroll = () => {
				let options = {
					root: null,
					rootMargin: `100px 0px ${document.body.clientHeight}px 0px`,
					threshold: 1
				};

				document.body.classList.add('is-top');

				const callback = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							document.body.classList.add('is-top');
						} else {
							document.body.classList.remove('is-top');
						}
					});
				};
				let observer = new IntersectionObserver(callback, options);
				observer.observe(document.body);
			};
			hiddenHeaderOnScroll();

		},
		footerMenu() {
			let footerMenu = document.querySelectorAll('.js-spMenu button');
			footerMenu.forEach(ele => {
				let content = ele.closest('.footer-nav-head').nextElementSibling;
				ele.addEventListener('click', () => {
					if (!ele.classList.contains(a)) {
						ele.classList.add(a);
						content.animate(
							{
								opacity: [0, 1],
								height: [0, content.querySelector('ul').offsetHeight + 'px'],
							},
							{
								duration: 300,
								easing: 'ease',
								fill: 'forwards',
							}
						);
					} else {
						ele.classList.remove(a);
						content.animate(
							{
								opacity: [1, 0],
								height: [content.querySelector('ul').offsetHeight + 'px', 0],
							},
							{
								duration: 300,
								easing: 'ease',
								fill: 'forwards',
							}
						);
					}
				});
			});
		},
		siteSearch() {
			let URL = THERMOS.va.isEnglish ? 'www.thermos.jp/english' : 'www.thermos.jp';
			$('.js-siteSearch-submit').on('click', (e) => {
				if ($(e.currentTarget).prev('.js-siteSearch-input').val()) {
					window.open(
						`https://www.google.co.jp/search?sitesearch=${URL}&q=${encodeURIComponent($(e.currentTarget).prev('.js-siteSearch-input').val())}`,
						'_blank',
						'location,status,menubar,toolbar,scrollbars,resizable,noopener'
					);
				} else {
					window.open('https://www.google.co.jp/search?sitesearch=${URL}', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
				}
			});
			$('.js-siteSearch-input').on('keydown', (e) => {
				if (e.keyCode === 13) {
					if ($(e.currentTarget).val()) {
						window.open(
							`https://www.google.co.jp/search?sitesearch=${URL}&q=${encodeURIComponent($(e.currentTarget).val())}`,
							'_blank',
							'location,status,menubar,toolbar,scrollbars,resizable,noopener'
						);
					} else {
						window.open('https://www.google.co.jp/search?sitesearch=${URL}', '_blank', 'location,status,menubar,toolbar,scrollbars,resizable,noopener');
					}
				}
			});
		},
		fileSize() {
			const bytesToSize = (bytes) => {
				const sizes = ['Bytes', 'KB', 'MB', 'GB'];
				if (bytes === 0) return '0 Byte';
				let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
				let convSize = Math.floor(bytes / Math.pow(1024, i) * Math.pow(10, 1)) / Math.pow(10, 1);
				// KBのとき、小数点切り捨て
				if (i === 1) convSize = Math.floor(convSize);
				return convSize + sizes[i];
			};

			document.querySelectorAll('.js-fileSize').forEach((ele) => {
				ele.textContent = (bytesToSize(ele.textContent));
			});
		},
		setProdSearch() {
			let $prodSearchForm = $('.prod-searchForm');
			let $formElement = $('#prodSearch');
			let MIN_H = (THERMOS.va.window.width >= THERMOS.va.device.sp) ? 110 : 90;

			// フォームの高さ処理
			const adjustHeight = () => {
				if (THERMOS.va.pathname === '/product/' || THERMOS.va.pathname === '/product/index.html') {
					let H = $prodSearchForm.find('.__inner').get(0).scrollHeight;
					if (($prodSearchForm.find('.__body').height() + MIN_H) <= H) { H = $prodSearchForm.find('.__body').height() + MIN_H; }
					$prodSearchForm.find('.__inner').css('height', H + 'px');
				} else {
					setTimeout(() => {
						$prodSearchForm.find('.__body').css('height', $prodSearchForm.find('.__body_inner').get(0).scrollHeight + 'px');
					}, 10);
				}
			};

			const addParam = () => {
				const thisSelect = $('select[name=category_select]').val();
				let addHTML = '';
				if (thisSelect === 'bottle' || thisSelect === 'lunchbox' || thisSelect === 'kitchen' ||
						thisSelect === 'mug_tumbler' || thisSelect === 'bag' || thisSelect === 'foodservice') {
					// 親カテゴリのあるものはタイプが選択されているかチェック
					if ($('input:radio[name="p_category"]:checked').val()) {
						if ($('input:radio[name="p_category"]:checked').val() === 'fryingpan-fixed_fryingpan') {
							// フライパンの場合さらに種類の絞り込みをチェック？
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_multipan">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_fryingpan">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_pot_pan">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_egg">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_set">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_fryingpan">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_pot_pan">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_handle">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_lid">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_lid">';
							addHTML += '<input type="hidden" name="p_category" value="fryingpan-egg_lid">';
						}
					} else {
						// 選択がなければ含まれているタイプをすべて追加
						switch (thisSelect) {
							case 'bottle':
								addHTML += '<input type="hidden" name="p_category" value="mug">';
								addHTML += '<input type="hidden" name="p_category" value="sport_jug">';
								addHTML += '<input type="hidden" name="p_category" value="straw">';
								addHTML += '<input type="hidden" name="p_category" value="cup">';
								addHTML += '<input type="hidden" name="p_category" value="twoway_threeway">';
								addHTML += '<input type="hidden" name="p_category" value="soda">';
								addHTML += '<input type="hidden" name="p_category" value="bottle_accessories">';
								break;
							case 'lunchbox':
								addHTML += '<input type="hidden" name="p_category" value="foodcontainer">';
								addHTML += '<input type="hidden" name="p_category" value="foodcontainer_pouch">';
								addHTML += '<input type="hidden" name="p_category" value="lunchjar">';
								addHTML += '<input type="hidden" name="p_category" value="lunchbox">';
								addHTML += '<input type="hidden" name="p_category" value="cutlery_ladle">';
								break;
							case 'kitchen':
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_fryingpan">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_multipan">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_fryingpan">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_pot_pan">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_egg">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_set">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_fryingpan">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_pot_pan">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_handle">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-fixed_lid">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-detachable_lid">';
								addHTML += '<input type="hidden" name="p_category" value="fryingpan-egg_lid">';
								addHTML += '<input type="hidden" name="p_category" value="shuttlechef">';
								addHTML += '<input type="hidden" name="p_category" value="easy_smoker">';
								addHTML += '<input type="hidden" name="p_category" value="foodstoragecontainer">';
								addHTML += '<input type="hidden" name="p_category" value="kitchen_tools">';
								break;
							case 'mug_tumbler':
								addHTML += '<input type="hidden" name="p_category" value="tumbler">';
								addHTML += '<input type="hidden" name="p_category" value="jug">';
								addHTML += '<input type="hidden" name="p_category" value="mug_cup">';
								addHTML += '<input type="hidden" name="p_category" value="can_holder">';
								addHTML += '<input type="hidden" name="p_category" value="teacup">';
								addHTML += '<input type="hidden" name="p_category" value="tumbler_accessories">';
								addHTML += '<input type="hidden" name="p_category" value="tableware">';
								break;
							case 'bag':
								addHTML += '<input type="hidden" name="p_category" value="cooler">';
								addHTML += '<input type="hidden" name="p_category" value="shopping_bag">';
								addHTML += '<input type="hidden" name="p_category" value="lunch_bag">';
								break;
							case 'foodservice':
								addHTML += '<input type="hidden" name="p_category" value="professional_stainlesspot">';
								addHTML += '<input type="hidden" name="p_category" value="professional_icepail_waterpot">';
								addHTML += '<input type="hidden" name="p_category" value="professional_pitcher">';
								addHTML += '<input type="hidden" name="p_category" value="professional_dispenser">';
								addHTML += '<input type="hidden" name="p_category" value="professional_tumbler">';
								addHTML += '<input type="hidden" name="p_category" value="professional_foodcontainer">';
								addHTML += '<input type="hidden" name="p_category" value="professional_foodjar">';
								addHTML += '<input type="hidden" name="p_category" value="professional_ricecontainer">';
								addHTML += '<input type="hidden" name="p_category" value="professional_shuttlechef">';
								addHTML += '<input type="hidden" name="p_category" value="professional_alfi">';
								break;
							default: break;
						}
					}
				} else {
					switch (thisSelect) {
						// タイプ選択なし
						case 'baby': addHTML += '<input type="hidden" name="p_category" value="baby">'; break;
						case 'pot': addHTML += '<input type="hidden" name="p_category" value="pot_icepail">'; break;
						case 'coffee_maker': addHTML += '<input type="hidden" name="p_category" value="coffee_maker">'; break;
						case 'outdoor': addHTML += '<input type="hidden" name="p_category" value="outdoor">'; break;
						case 'mountain': addHTML += '<input type="hidden" name="p_category" value="mountain">'; break;
						case 'cycling': addHTML += '<input type="hidden" name="p_category" value="bicycle_bottle">'; break;
						case 'maintenance': addHTML += '<input type="hidden" name="p_category" value="maintenance">'; break;
						default: break;
					}
				}
				return addHTML;
			}

			// ----------------------------------- ▲ FUNCTIONS ▲ --------------------------------------------------------------------

			// カテゴリー選択
			if ($('#prodSearch_category').val() !== '') {
				// 引き継ぎの場合
				$(`.__field[data-category=${$('#prodSearch_category').val()}]`).addClass(a);
			}
			$('#prodSearch_category').on('change', () => {
				// 選択中の項目を全て解除
				$('.__field').each((idx, ele) => { $(ele).removeClass(a); });
				$('input[type=radio], input[type=checkbox]').each((idx, ele) => { $(ele).prop('checked', false); });

				if ($('#prodSearch_category').val() !== '') {
					$(`.__field[data-category=${$('#prodSearch_category').val()}]`).addClass(a);
				}
				adjustHeight();
			});

			// タイプ選択
			$('input[name="p_category"]').each((idx, ele) => {
				if ($(ele).prop('checked')) {
					// 引き継ぎの場合
					$(`.__field[data-type*=${$(ele).attr('data-type')}]`).addClass(a);
				}

				$(ele).on('change', (e) => {
					// 配下の選択中の項目を全て解除 ※水筒／タンブラー・マグカップ／バッグ／業務用品カテゴリ以外
					let thisType = $(e.currentTarget).attr('data-type');
					if (thisType !== 'bottle' && thisType !== 'mug_tumbler' && thisType !== 'bag' && thisType !== 'foodservice') {
						$('[data-type]').find('input[type=radio], input[type=checkbox]').each((idx2, ele2) => { $(ele2).prop('checked', false); });
						$('[data-type]').removeClass(a);
					}
					$(`.__field[data-type*=${$(e.currentTarget).attr('data-type')}]`).addClass(a);

					adjustHeight();
				})
			});

			// 詳細検索フォーム開閉
			if (THERMOS.va.pathname === '/product/' || THERMOS.va.pathname === '/product/index.html' ||
					THERMOS.va.pathname === '/english/product/' || THERMOS.va.pathname === '/english/product/index.html') {
				// 製品TOPのみアコーディオン
				$('.__subSwitch').on('click', (e) => {
					$('.__subSwitch').toggleClass('is-open');
					$prodSearchForm.toggleClass('is-open');
					if (!$prodSearchForm.hasClass('is-open')) {
						if (THERMOS.va.window.width > THERMOS.va.device.sp) {
							$prodSearchForm.find('.__inner').css('height', '250px');
						} else if (THERMOS.va.window.width <= THERMOS.va.device.sp && THERMOS.va.window.width >= 640) {
							$prodSearchForm.find('.__inner').css('height', '222px');
						} else {
							$prodSearchForm.find('.__inner').css('height', '250px');
						}
					} else {
						$prodSearchForm.find('.__inner').css('height', $prodSearchForm.find('.__inner').get(0).scrollHeight + 'px');
					}
				});
			} else {
				// 製品TOP以外はプルダウン（absolute）
				$prodSearchForm.find('.__head').on('click', (e) => {
					$(e.currentTarget).toggleClass('is-open');
					$prodSearchForm.toggleClass('is-open');
					if (!$prodSearchForm.hasClass('is-open')) {
						$prodSearchForm.find('.__body').css('height', '0px');
					} else {
						$prodSearchForm.find('.__body').css('height', $prodSearchForm.find('.__body_inner').get(0).scrollHeight + 'px');
					}
				});
			}

			// 検索ボタン押下
			$prodSearchForm.find('.js-submit').on('click', () => {
				let addHTML = addParam();
				$formElement.append(addHTML);
				$formElement.submit();
			});

			// クリアボタン押下
			$prodSearchForm.find('.js-clear').on('click', () => {
				if ($('.prod-cat').length) {
					let thisCat = THERMOS.va.pathname.split('/')[2].replace(/\.html/, '');
					$('#prodSearch_keyword').val('');
					$prodSearchForm.find('input[type=radio], input[type=checkbox]').each((idx2, ele2) => { $(ele2).prop('checked', false) });
					$('.__field').removeClass(a);
					$(`.__field[data-category=${thisCat}]`).addClass(a);
					adjustHeight();
				} else if ($('.prod-series').length) {
					$('#prodSearch_keyword').val('');
					$('.__field[data-type]').find('input[type=radio], input[type=checkbox]').each((idx2, ele2) => { $(ele2).prop('checked', false) });
					adjustHeight();
				} else {
					$('#prodSearch_keyword').val('');
					$('#prodSearch_category').val('');
					$('.__field').removeClass(a);
					$prodSearchForm.find('input[type=radio], input[type=checkbox]').each((idx2, ele2) => { $(ele2).prop('checked', false) });
					adjustHeight();
				}
			});

			// ＜初期表示＞カテゴリTOPの検索はカテゴリ固定
			if ($('.prod-cat').length) {
				let thisCat = (THERMOS.va.isEnglish) ? THERMOS.va.pathname.split('/')[3].replace(/\.html/, '') : THERMOS.va.pathname.split('/')[2].replace(/\.html/, '');
				$('#prodSearch_category').val(thisCat);
				$(`.__field[data-category=${thisCat}]`).addClass(a);
			}

			// ＜初期表示＞シリーズ一覧ページの検索はカテゴリ・タイプ固定
			if ($('.prod-series').length) {
				let thisCat;
				if ($('.mod-head01-cat').length) {
					thisCat = $('.mod-head01-cat').attr('data-category');
				} else {
					thisCat = (THERMOS.va.isEnglish) ? THERMOS.va.pathname.split('/')[4].replace(/\.html/, '') : THERMOS.va.pathname.split('/')[3].replace(/\.html/, '');
				}
				$('#prodSearch_category').val(thisCat);
				$(`.__field[data-category=${thisCat}]`).addClass(a);

				if ($('.mod-head01-cat').length) {
					let thisType = THERMOS.va.pathname.split('/')[3].replace(/\.html/, '');
					$(`input[name=p_category][id=type-${thisType}]`).prop('checked', true);

					// 別タイプで検索項目が共通
					if (thisCat === 'bottle') {
						$('.__field[data-type=bottle]').addClass(a);
					} else if (thisCat === 'mug_tumbler' && thisType !== 'tableware') {
						$('.__field[data-type=mug_tumbler]').addClass(a);
					} else if (thisCat === 'bag') {
						$('.__field[data-type=bag]').addClass(a);
					} else {
						$(`.__field[data-type=${thisType}]`).addClass(a);
					}
				}
			}
		},

		loadDelayScript(){
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.footerMenu();
			_this.siteSearch();
			_this.fileSize();

			if (document.getElementsByClassName('header').length) {
				_this.headerMenu();
			}

			if ($('.prod-searchForm').length) { _this.setProdSearch(); }
		}
	};

	$(() => THERMOS.localDecision() ? THERMOS.localLoading() : THERMOS.loadDelayScript());
})(window.jQuery);
